import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { CreateFragmentFromLoggerPage } from '@app/modules/fragments/screens/add/CreateFragmentFromLoggerPage';
import { LiveTopicsPanel } from '@app/modules/logger/screens/stream/features/live-topics/panel/LiveTopicsPanel';
import { TopicDetailPanel } from '@app/modules/logger/screens/stream/features/live-topics/panel/topic-detail-panel/TopicDetailPanel';
import { CreateJointFragmentFromEditor } from '@app/modules/logger/screens/stream/fragment-editor/components/save/CreateJointFragmentFromEditor';
import { useStreamSettingsStore } from '@app/modules/logger/screens/stream/stores/stream-screen-settings.store';

/**
 * Renders the stream drawer panel content based on stream screen settings store.
 * Open state and content type survive navigation (e.g. stream → status → stream).
 */
export function StreamDrawerContent() {
  const drawerContent = useStreamSettingsStore((s) => s.drawerType);
  const station = useActiveStation();

  if (!drawerContent) {
    return null;
  }

  switch (drawerContent) {
    case 'live-topics':
      return <LiveTopicsPanel />;
    case 'live-topics-standalone':
      return <TopicDetailPanel />;
    case 'create-fragment':
      return <CreateFragmentFromLoggerPage station={station} />;
    case 'create-joint-fragment':
      return <CreateJointFragmentFromEditor />;
    default:
      return null;
  }
}
